import React from "react";
import SectionHeading from "./SectionHeading";

const steps = [
  {
    number: "01",
    title: "Discovery & Scoping",
    description:
      "Deep-dive sessions to map your data landscape, define success metrics, and identify quick wins.",
  },
  {
    number: "02",
    title: "Data Strategy",
    description:
      "Data audit, pipeline architecture, and annotation workflows that give your models the strongest foundation.",
  },
  {
    number: "03",
    title: "Model Development",
    description:
      "Rapid prototyping followed by rigorous benchmarking — every model earns its place before it ships.",
  },
  {
    number: "04",
    title: "Deploy & Monitor",
    description:
      "Production-ready APIs and monitoring dashboards so your AI stays accurate and reliable over time.",
  },
];

export default function WorkProcess() {
  return (
    <section className="bg-[#F8F8FB] py-20 border-t border-gray-200/60">
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <div className="max-w-3xl mx-auto mb-16">
          <SectionHeading
            eyebrow="How We Work"
            title="From Idea to Production AI"
            theme="light"
            titleClassName="text-[#111827]"
            showLine={false}
          />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector */}
              {index !== steps.length - 1 && (
                <div className="hidden xl:block absolute top-1/2 -right-6 w-6 h-[2px] bg-gray-200"></div>
              )}

              {/* Card */}
              <div className="group bg-white border border-[#ECECEC] rounded-2xl p-7 min-h-[300px] flex flex-col justify-between transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#355dff]">
                <div>
                  <h1 className="text-5xl font-extrabold text-blue-100 transition-colors duration-300 group-hover:text-[#355dff]">
                    {step.number}
                  </h1>
                  <h3 className="mt-6 text-xl font-bold text-[#111827]">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-[14px] leading-7 text-gray-500">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}